import { Link } from '@inertiajs/react';

import Icon from '@/components/public/ui/Icon';
import Section from '@/components/public/ui/Section';
import SectionHeader from '@/components/public/ui/SectionHeader';
import { QuickAccessItems, ColorConfiguration } from '@/data/pages/landing/data';
import { trackUmamiEvent } from '@/lib/analytics';

// Colored left-edge accent revealed on hover, per brand colour.
const edgeHover: Record<'primary' | 'secondary' | 'tertiary', string> = {
  primary: 'group-hover:bg-primary',
  secondary: 'group-hover:bg-gold-leaf',
  tertiary: 'group-hover:bg-tertiary',
};

const QuickAccessHub = () => {
  return (
    <Section spacing="md" aria-labelledby="quick-access-heading">
      <SectionHeader
        eyebrow="Acesso rápido"
        title="O que pode fazer aqui"
        intro="Aceda rapidamente aos serviços e informações mais procurados."
      />
      <h2 id="quick-access-heading" className="sr-only">
        Acesso rápido aos serviços
      </h2>

      {/* Unified institutional grid: hairline dividers via 1px gap over the line colour. */}
      <div className="border-line bg-line grid grid-cols-1 gap-px overflow-hidden rounded-lg border sm:grid-cols-2 lg:grid-cols-3">
        {QuickAccessItems.map((item) => {
          const config = ColorConfiguration[item.color];
          return (
            <Link
              key={item.title}
              href={item.href}
              onClick={() =>
                trackUmamiEvent('quick_access_click', { title: item.title, target: item.href })
              }
              className="group bg-surface relative flex min-h-[170px] flex-col p-6 transition-colors duration-150 hover:bg-white"
            >
              <span
                className={`absolute inset-y-0 left-0 w-[3px] bg-transparent transition-colors duration-150 ${edgeHover[item.color]}`}
              />
              <div
                className={`mb-3 flex h-11 w-11 items-center justify-center rounded-lg ${config.iconBg}`}
                aria-hidden="true"
              >
                <span className="text-2xl leading-none">{item.icon}</span>
              </div>
              <h3 className="font-headline text-on-surface text-lg font-semibold">{item.title}</h3>
              <p className="text-on-surface-light mt-1.5 text-sm leading-snug">
                {item.description}
              </p>
              <span className="text-primary mt-auto inline-flex items-center gap-1.5 pt-4 text-sm font-bold">
                Aceder
                <Icon
                  name="arrow_forward"
                  size="sm"
                  className="transition-transform group-hover:translate-x-1"
                />
              </span>
            </Link>
          );
        })}
      </div>
    </Section>
  );
};

export default QuickAccessHub;
